import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

export default function About(){
  const { t } = useTranslation()
  return (
    <main>
      <Helmet><title>{t('about.title')} — Pearl of Galia</title></Helmet>

      {/* HERO */}
      <section className="hero">
        <img src="/images/logo-removebg-preview (1).png" alt="Pearl of Galia logo" className="brand-logo-hero" />
        <div className="brand">
          <h1>
            <span>{t('about.story.title')}</span>
          </h1>
          <p className="tagline">{t('about.story.tagline')}</p>
        </div>
      </section>

      {/* COMPANY OVERVIEW */}
      <section className="room">
        <div className="grid">
          <div>
            <h2 className="section-title">{t('about.who.title')}</h2>
            <p><strong>{t('about.who.intro')}</strong></p>
            <p>{t('about.who.mission')}</p>
            <p>{t('about.who.network')}</p>
          </div>
          <div>
            <img src="/images/distribution_1-removebg-preview.png" alt="Our distribution network" />
          </div>
        </div>
      </section>

      {/* OUR PROCESS */}
      <section className="room">
        <h2 className="section-title">{t('about.process.title')}</h2>
        <div className="process-grid">
          <div className="process-step">
            <div className="step-number">01</div>
            <h3>{t('about.process.sourcing.title')}</h3>
            <p>{t('about.process.sourcing.desc')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">02</div>
            <h3>{t('about.process.quality.title')}</h3>
            <p>{t('about.process.quality.desc')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">03</div>
            <h3>{t('about.process.logistics.title')}</h3>
            <p>{t('about.process.logistics.desc')}</p>
          </div>
          <div className="process-step">
            <div className="step-number">04</div>
            <h3>{t('about.process.service.title')}</h3>
            <p>{t('about.process.service.desc')}</p>
          </div>
        </div>
      </section>

      {/* EXPERTISE */}
      <section className="room">
        <div className="grid">
          <div>
            <img src="/images/tasting-removebg-preview.png" alt="Professional tasting" />
          </div>
          <div>
            <h2 className="section-title">{t('about.expertise.title')}</h2>

            <div className="expertise-item">
              <h3>{t('about.expertise.matcha.title')}</h3>
              <p>{t('about.expertise.matcha.desc')}</p>
            </div>

            <div className="expertise-item">
              <h3>{t('about.expertise.caviar.title')}</h3>
              <p>{t('about.expertise.caviar.desc')}</p>
            </div>

            <div className="expertise-item">
              <h3>{t('about.expertise.distribution.title')}</h3>
              <p>{t('about.expertise.distribution.desc')}</p>
            </div>

            <div className="expertise-item">
              <h3>{t('about.expertise.consultation.title')}</h3>
              <p>{t('about.expertise.consultation.desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CERTIFICATIONS */}
      <section className="room">
        <h2 className="section-title">{t('about.certifications.title')}</h2>
        <div className="certifications">
          <div className="cert-item">
            <h3>{t('about.certifications.haccp.title')}</h3>
            <p>{t('about.certifications.haccp.desc')}</p>
          </div>
          <div className="cert-item">
            <h3>{t('about.certifications.organic.title')}</h3>
            <p>{t('about.certifications.organic.desc')}</p>
          </div>
          <div className="cert-item">
            <h3>{t('about.certifications.sustainable.title')}</h3>
            <p>{t('about.certifications.sustainable.desc')}</p>
          </div>
        </div>
      </section>
    </main>
  )
}
